import React from 'react';
import { trackEPassPageEvent } from '../../utils/omnitureTracking';
type BenefitsProps = {
  redirectToCabsPage: () => void;
};
const Benefits = ({ redirectToCabsPage }: BenefitsProps) => {
  const onBookNowClick = () => {
    trackEPassPageEvent('Cab_SEO_Epass_Mysafety_Booknow_Click');
    redirectToCabsPage();
  };
  return (
    <section
      style={{ marginBottom: '0px' }}
      className="benifits dark__text section__bdr"
    >
      <p className="section__heading latoBlack">
        Benefits of Booking Your Cab with Us
      </p>
      <div
        style={{ borderTop: 'solid 1px #d4d4d4' }}
        className="benifits__tile"
      >
        <p className="safty__text latoBlack">
          <span className="epass__sprite safty__icon appendRight10"></span>
          <span className="blueText">My</span>Safety - Book Hygienic Cabs
        </p>
        <div className="safty__list__wrap">
          <ul className="safty__list">
            <li>
              <span className="safty__icon__wrap">
                <span className="drivermask__icon epass__sprite"></span>
              </span>{' '}
              Driver with Masks
            </li>
            <li>
              <span className="safty__icon__wrap">
                <span className="sanitizedcab__icon epass__sprite"></span>
              </span>{' '}
              Sanitized Cabs
            </li>
            <li>
              <span className="safty__icon__wrap">
                <span className="aarogyasetu__icon epass__sprite"></span>
              </span>{' '}
              Drivers with Aarogya Setu app
            </li>
            <li>
              <span className="safty__icon__wrap">
                <span className="handsanitizers__icon epass__sprite"></span>
              </span>{' '}
              Hand Sanitizers
            </li>
          </ul>
          <a
            className="blueText latoBlack capText"
            href={'https://www.makemytrip.com/promos/mysafety.html?tab=cabs'}
            onClick={() =>
              trackEPassPageEvent('Cabs_SEO_Epass_Mysafety_Learn_More_Click')
            }
            target="_blank"
          >
            Learn More
          </a>
        </div>
      </div>
      <button
        id="beforeStateGuidelines"
        className="epass__form__btn pushBottom"
        onClick={onBookNowClick}
      >
        {' '}
        Book Now
      </button>
    </section>
  );
};
export default Benefits;
